import { Component, ChangeDetectionStrategy } from '@angular/core';
import Keycloak from 'keycloak-js';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { sentryLogger } from 'shared/core';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatToolbar, MatButton],
})
export class MenuBarComponent {
  constructor(private readonly keycloak: Keycloak) {}

  onLogoutClicked() {
    this.keycloak
      .logout()
      .then((result) =>
        sentryLogger.info('User logout completed', { result: result ?? null }),
      );
  }
}
